import {useDocumentDataOnce} from 'react-firebase-hooks/firestore'
import {db} from 'configs/firebase'

export default function usePartnerOnce(partnerId) {
  return useDocumentDataOnce(partnerId ? db.doc(`partners/${partnerId}`) : null)
}
